import { AbstractControl, FormControl, ValidatorFn } from '@angular/forms';
import { DateTime } from 'luxon';
import { validateCreditCardNumber } from './validate-credit-card-number';

export function checkIfMatchingPasswords(
  passwordKey: string,
  passwordConfirmationKey: string
) {
  return (control: AbstractControl) => {
    const passwordInput = control.get(passwordKey);
    const passwordConfirmationInput = control.get(passwordConfirmationKey);
    if (passwordInput.value !== passwordConfirmationInput.value) {
      passwordConfirmationInput.setErrors({ notEquivalent: true });
      return { notEquivalent: true };
    }
    return null;
  };
}

export function checkCreditCard(): ValidatorFn {
  return (control: AbstractControl) => {
    const isValid = validateCreditCardNumber(control.value);
    return isValid ? null : { CCValid: isValid };
  };
}
export function checkCCExpireValidator(
  expYear: string,
  expMonth: string
): ValidatorFn {
  return (control: FormControl) => {
    if (control) {
      if (control?.get(expYear)?.value && control?.get(expMonth)?.value) {
        const exprDate: DateTime = DateTime.fromFormat(
          `${control?.get(expYear)?.value}-${control?.get(expMonth)?.value}`,
          'yyyy-MM'
        ).endOf('month');
        exprDate < DateTime.now()
          ? control.get(expMonth).setErrors({ invalidMonth: true })
          : control.get(expMonth).setErrors(null);
      }
    } else {
      return null;
    }
  };
}

export function checkZipCode(country: string, zipCode: string): ValidatorFn {
  return (control: FormControl) => {
    let postalCodeRegex;
    if (control) {
      if (control?.get(country)?.value && control?.get(zipCode)?.value) {
        switch (control?.get(country)?.value) {
          case 'United States':
            postalCodeRegex = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/;
            break;
          case 'Canada':
            postalCodeRegex = /^([A-Z][0-9][A-Z])\s*([0-9][A-Z][0-9])$/;
            break;
          case 'Mexico':
            postalCodeRegex = /^\d{4,5}$/;
            break;
          default:
            postalCodeRegex = /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/;
        }
        !postalCodeRegex.test(control?.get(zipCode)?.value)
          ? control.get(zipCode).setErrors({ invalidZip: true })
          : control.get(zipCode).setErrors(null);
      }
    } else {
      return null;
    }
  };
}
